import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { DASHBOARD_BASE_URL, printDebugLog, SUCCESS } from "../../constants/Constants";
import { Button, Grid } from "@mui/material";
import CustomDataGrid from "../../global/CustomDataGrid";
import axios from "axios";
import DialogBox from "../../global/DialogBox";
import { EmployeeUpdate } from "./EmployeeUpdate";
import { USERCREATION, USERUPDATION } from "../../constants/Permissions";
import { fetchHotelEmployee } from "../global/commonNetworkController";


const Employee = () => {

    const { activeShopHash, authUser, isRoleAllowed, showMessageDialog } = useAuth();
    const [listEmployee, setListEmployee] = useState([]);
    const [loader, setLoader] = useState(false);

    const [showDialog, setShowDialog] = useState(false);
    const [isEditProduct, setEditProduct] = useState(false);

    const INITIAL_EMPLOYEE = {
        name: "",
        userEmail: "",
        jcId: "",
        activeStatus: 1,
        phone: "",
        createdDate: "",
        passWord: "",
        roles: [],
        employeeType: "",
        firstTimeLogin: false,
        haveSalaryComponent: false,
    };

    const [empCount, setEmpCount] = useState(0);
    const [empCreate, setEmpCreate] = useState(false);
    const [myRoles, setMyRoles] = useState(new Map());
    const [myRolesRules, setMyRolesRules] = useState(false);
    const [employeeSingleData, setSingleEmployeeData] = useState(INITIAL_EMPLOYEE);

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [checkData, setCheckData] = useState("");

    useEffect(() => {
        getHotelEmployees();
    }, []);

    const getHotelEmployees = async () => {
        await fetchHotelEmployee({
            authUser: authUser,
            activeShopHash: activeShopHash,
            setLoader: setLoader,
            onResponseCallback: (payload) => {
                if (payload !== null) {
                    setListEmployee(payload?.data ?? []);
                    setEmpCount(Number(payload?.empCount ?? 0));
                    setEmpCreate(payload?.empCreate ?? false);
                } else {
                    setListEmployee([]);
                    setEmpCount(0);
                    setEmpCreate(false);
                }
            }
        })
    };

    const handleEmployeeSubmit = async () => {
        setFormSubmitted(true);
        if (!isValid()) {
            return;
        }
        const catgUrl = `${DASHBOARD_BASE_URL}persist-employee`;
        employeeSingleData.roles = [];
        let jsonObject = {};
        myRoles.forEach((value, key) => {
            jsonObject[key] = value
        });
        //console.log(jsonObject);
        setLoader(true);
        const filledData = {
            payLoad: {
                apiToken: authUser.apiToken,
                jcId: employeeSingleData.jcId,
                shopHash: activeShopHash.id,
                phone: employeeSingleData.phone,
                activeStatus: parseInt(employeeSingleData.activeStatus),
                name: employeeSingleData.name,
                userEmail: employeeSingleData.userEmail,
                value: employeeSingleData.passWord,
                employeeType: employeeSingleData.employeeType,
                haveSalaryComponent: employeeSingleData.haveSalaryComponent,
                roles: jsonObject
            }
        };
        //console.log("handleEmployeeSubmit filledData => ", filledData);
        setShowDialog(false);
        axios.post(catgUrl, filledData)
            .then(response => {
                setLoader(false);
                printDebugLog("responses => ", response.data);
                if (response.data.status === SUCCESS) {
                    getHotelEmployees();
                }
            }).catch(error => {
                setLoader(false);
                console.error("error : ", error);
                setFormSubmitted(false);
                //window.location.href = "#/error";
            });
    };

    const getErrorMessage = (field) => {
        if (!formSubmitted) {
            return;
        } else if (!employeeSingleData[field]) {
            return 'Field is required';
        }
    }

    const isValid = () => {
        let isEmployeeDataValid = true;
        if (!employeeSingleData.name || !employeeSingleData.phone || !employeeSingleData.userEmail) {
            isEmployeeDataValid = false;
        }
        return isEmployeeDataValid;
    }

    const addRoles = (key, array) => {
        const val = array?.[key] ?? false;
        setMyRoles(myRoles.set(key, val));
    };

    const handleCellClick = (cellValues, edit = true) => {
        printDebugLog("handleCellClick", cellValues);
        setSingleEmployeeData(prev => ({
            ...prev, ...cellValues,
        }));
        Object.keys(authUser.roles).map((key) => addRoles(key, cellValues.roles));
        setShowDialog(true);
        setEditProduct(edit);
    }

    const handleDialogClose = () => {
        // console.log("handleDialogClose");

        setSingleEmployeeData({
            name: "",
            userEmail: "",
            jcId: "",
            activeStatus: 1,
            phone: "",
            createdDate: "",
            passWord: "",
            roles: [],
            haveSalaryComponent: false,
        })
        //setCheckAccounting(false);
        Object.keys(authUser.roles).map((key) => (
            setMyRoles(myRoles.set(key, authUser.roles[key]))
        ));
        setShowDialog(false);
        setEditProduct(false);
        setFormSubmitted(false);
        setMyRolesRules(true);
    };



    const columns = [
        {
            field: 'name', headerName: 'Name', width: 150, renderCell: (params) => (
                <span style={{ fontWeight: 'bold', color: '#151b45', fontSize: "18px" }}>{params.value}</span>
            ),
        },
        { field: 'employeeType', headerName: 'Emp. Type', width: 150 },
        { field: 'userEmail', headerName: 'Email', width: 200 },
        {
            field: 'phone', headerName: 'Phone', width: 150, renderCell: (params) => (
                <span style={{ color: '#151b45' }}>{params.value}</span>
            ),
        },
        {
            field: 'activeStatusStr', headerName: 'Status', width: 150, valueGetter: (params) => params.row.activeStatusStr,
            renderCell: (params) => (
                <span style={{ color: params.value === 'Active' ? '#0f633b' : "#7a1904" }}>{params.value}</span>
            ),
        },
        {
            field: 'createdDate', headerName: 'On', width: 170, renderCell: (params) => (
                <span style={{ color: '#151b45' }}>{params.value}</span>
            ),
        },
        {
            field: "edit",
            headerName: "Edit",
            width: 90,
            renderCell: (cellValues) => {
                return (
                    <Button variant="contained"
                        color="primary"
                        onClick={() => {
                            if (isRoleAllowed(USERUPDATION)) {
                                handleCellClick(cellValues.row);
                            }
                        }}
                    >Edit</Button>
                );
            }
        }
    ]

    const renderDialogAction = () => {
        return (
            <React.Fragment>
                {
                    <Button variant="contained" onClick={handleEmployeeSubmit}>
                        {isEditProduct ? "Update" : "Submit"}
                    </Button>
                }
                <Button variant="contained" onClick={handleDialogClose}>
                    Dismiss
                </Button>
            </React.Fragment>
        );
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ padding: 10 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{ boxShadow: 10 }}
                            style={{ float: "right" }}
                            onClick={() => {
                                if (empCreate) {
                                    if (isRoleAllowed(USERCREATION)) {
                                        handleCellClick(INITIAL_EMPLOYEE, false);
                                    }
                                } else {
                                    showMessageDialog(`You don't have enough employee ${empCount} to create`);
                                }

                            }}>
                            Add New Employee
                        </Button>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <CustomDataGrid
                        getRowId={row => row.empId}
                        rows={listEmployee}
                        columns={columns}
                        loading={loader}
                        title="Employee List"

                    />
                </Grid>
                <DialogBox
                    showDialog={showDialog}
                    title={"Employee Update"}
                    onClose={handleDialogClose}
                    dialogContent={
                        <EmployeeUpdate
                            adminRoles={authUser?.roles ?? []}
                            employeeSingleData={employeeSingleData}
                            setSingleEmployeeData={setSingleEmployeeData}
                            setMyRoles={setMyRoles}
                            setMyRolesRules={setMyRolesRules}
                            myRoles={myRoles}
                            myRolesRules={myRolesRules}
                            formSubmitted={formSubmitted}
                            getErrorMessage={getErrorMessage}
                            setCheckData={setCheckData}
                        />
                    }
                    dialogActions={renderDialogAction()}
                />
            </Grid>
        </>
    )
}
export { Employee };